var _excluded = ["options", "selectedOptions", "id", "variant", "selectEntireTile", "onChange", "labelProps"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React, { useMemo } from 'react';
import { Checkbox } from './Checkbox';
import { Div } from '@kizi/core-components';
export var CheckboxGroup = function CheckboxGroup(_ref) {
  var options = _ref.options,
      _ref$selectedOptions = _ref.selectedOptions,
      selectedOptions = _ref$selectedOptions === void 0 ? [] : _ref$selectedOptions,
      id = _ref.id,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? 'main' : _ref$variant,
      selectEntireTile = _ref.selectEntireTile,
      _ref$onChange = _ref.onChange,
      onChange = _ref$onChange === void 0 ? function () {
    return undefined;
  } : _ref$onChange,
      labelProps = _ref.labelProps,
      divProps = _objectWithoutProperties(_ref, _excluded);

  var handleChange = function handleChange(val, selected) {
    var arr = _toConsumableArray(selected);

    var idx = arr.indexOf(val);

    if (idx > -1) {
      arr.splice(idx, 1);
    } else {
      arr.push(val);
    }

    return arr;
  };

  var handleIfChecked = function handleIfChecked(value, selected) {
    return selected.includes(value) || typeof value === 'number' && selected.includes('' + value);
  };

  return useMemo(function () {
    return /*#__PURE__*/React.createElement(Div, _extends({
      variant: "checkboxGroup"
    }, divProps, {
      width: variant === 'tile' ? 'fit-content' : 'initial'
    }), options === null || options === void 0 ? void 0 : options.map(function (_ref2, key) {
      var label = _ref2.label,
          value = _ref2.value,
          dependsOn = _ref2.dependsOn;
      return /*#__PURE__*/React.createElement(Checkbox, {
        checked: handleIfChecked(value, selectedOptions),
        key: "checkbox-".concat(id ? id + '-' : '').concat(key),
        onClick: function onClick() {
          return onChange(handleChange(value, selectedOptions));
        },
        selectEntireTile: selectEntireTile,
        variant: variant,
        label: label,
        value: value,
        labelProps: labelProps,
        containerProps: {
          my: 3,
          ml: dependsOn ? 3 : 0,
          // DO NOT USE THIS PROP/COMPONENT, IT WILL BE REMOVED
          alignContent: 'center',
          flexDirection: 'row-reverse',
          justifyContent: 'flex-end'
        },
        css: {
          mr: 2
        }
      });
    }));
  }, [options, selectedOptions, onChange]);
};